module.exports = {
  VERSION: "1.40.0", // version of frontend application
  MIN_API_VERSION: "25.07.0", // should be in sync with the API version
}
